<template>
  <v-card :loading="form.processing" flat>
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" class="mt-4" :disabled="isReadonly || form.processing">
        <div class="label mb-2">Name</div>
        <v-text-field
          v-model="form.name"
          :rules="[validationRules.required]"
          :error="form.errors.name"
          :error-messages="form.errors.name"
          solo
          flat
          outlined
          dense
          placeholder="Name"
        />
        <div class="label mb-2">Email</div>
        <v-text-field
          v-model="form.email"
          :rules="[validationRules.required]"
          :error="form.errors.email"
          :error-messages="form.errors.email"
          type="email"
          solo
          flat
          outlined
          dense
          placeholder="Email"
        />
        <div class="label mb-2">Password</div>
        <v-text-field
          v-model="form.password"
          :error="form.errors.password"
          :error-messages="form.errors.password"
          solo
          flat
          outlined
          dense
          placeholder="Password"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-container fluid>
        <v-row justify="end">
          <v-col md="3" cols="12">
            <v-btn block depressed outlined @click="cancel">Cancel</v-btn>
          </v-col>
          <v-col md="3" cols="12">
            <v-btn
              block
              depressed
              color="primary"
              :disabled="isReadonly || form.processing"
              @click="submit"
            >
              Save Changes
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'EmployeeForm',
  props: {
    mode: {
      type: String,
      required: true,
      validator: () => ['add', 'edit', 'view'],
    },
    employee: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        password: null,
        role: 'admin',
      }),
    }
  },
  computed: {
    isReadonly() {
      return this.mode === 'view'
    },
  },
  watch: {
    $props: {
      immediate: true,
      handler() {
        this.validateProps()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    validateProps() {
      if ((this.mode === 'edit' || this.mode === 'view') && !this.employee) {
        console.error(
          `employee props must be provided for 'edit' and 'view' mode`
        )
      }
    },
    init() {
      if (this.mode != 'add' && this.employee != null) {
        _.merge(this.form, this.employee)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.mode === 'add') {
          this.form.post('/employees')
        } else if (this.mode === 'edit') {
          this.form.put(`/employees/${this.employee.id}`)
        }
      }
    },
  },
}
</script>
